/* eslint-disable */
import $ from 'jquery';
import 'jquery-mask-plugin';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import Swiper from 'swiper/swiper-bundle.js';

window.$ = $;
window.jQuery = $;

const urlParams = new URLSearchParams(window.location.search);
const debug = urlParams.get('debug');
const isDebug = debug && debug == 1;

// gallery
$(() => {
    Fancybox.bind("[data-fancybox]", {});
});

// phones
$(() => {
    $('[name="phone"]').mask('+0 000 000-00-00', {
        onChange: function(val, e, currentField, options) {
            const cleanVal = val.replace(/\D/g, '');
            
            if (cleanVal.indexOf('8') === 0) {
                const newValue = '+7' + cleanVal.substring(1);
                $(currentField).val(newValue);
            }
        }
    });
    // $('[name="phone"]').mask('0#', {
    //     maxlength: false,
    //     onKeyPress: function(value, e, field, options) {
    //         // Разрешаем только цифры
    //         field.val(value.replace(/\D/g, ''));
    //     }
    // });
});

// news slider
$(() => {
    new Swiper(".news__slider", {
        slidesPerView: 3,
        spaceBetween: 32,
        navigation: {
            nextEl: ".news .swiper-button-next",
            prevEl: ".news .swiper-button-prev",
        },
        pagination: {
            el: ".news .swiper-pagination",
        },
        breakpoints: {
            320: {
                slidesPerView: 1.46,
                spaceBetween: 16,
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 32,
            }
        }
    });
});

// tariffs slider
$(() => {
    new Swiper(".tariffs__slider", {
        slidesPerView: 2,
        spaceBetween: 32,
        navigation: {
            nextEl: ".tariffs .swiper-button-next",
            prevEl: ".tariffs .swiper-button-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1.1,
                spaceBetween: 14,
            },
            768: {
                slidesPerView: 1.2,
                spaceBetween: 16,
            },
            1025: {
                slidesPerView: 2,
                spaceBetween: 32,
            }
        }
    });
});

// region cities
$(() => {
    const $section = $('.region-cities');
    if (!$section.length) return;

    const $toggle = $section.find('.region-cities__toggle');
    const $toggleText = $toggle.find('.region-cities__toggle-text');
    const citiesCount = $section.find('.region-cities__city').length;
    const tabletQuery = window.matchMedia('(max-width: 1024px)');

    const getVisibleLimit = () => (tabletQuery.matches ? 14 : 21);

    const updateToggleVisibility = () => {
        if (citiesCount > getVisibleLimit()) {
            $toggle.addClass('visible');
        } else {
            $toggle.removeClass('visible');
            $section.removeClass('open');
            $toggleText.text('Развернуть');
        }
    };

    updateToggleVisibility();

    if (tabletQuery.addEventListener) {
        tabletQuery.addEventListener('change', updateToggleVisibility);
    } else if (tabletQuery.addListener) {
        tabletQuery.addListener(updateToggleVisibility);
    }

    $toggle.on('click', function() {
        $section.toggleClass('open');
        $toggleText.text($section.hasClass('open') ? 'Свернуть' : 'Развернуть');
    });
});

// faq
$(() => {
    $('.faq__item').on('click', function() {
        if ($(this).hasClass('active')) {
            $('.faq__item').removeClass('active');
            return;
        }
        $('.faq__item').removeClass('active');
        $(this).addClass('active');
    });
});

// tariffs 
$(() => {
    // more
    $('.tariffs__item .item__more').on('click', function() {
        $(this).parents('.tariffs__item').toggleClass('open');
    });
    $('.tariffs__types button').on('click', function() {
        const type = $(this).data('type');

        $('.tariffs__types button').removeClass('active');
        $('.tariffs__items').removeClass('active');

        if ($('.tariffs__more').length) {
            $('.tariffs__more').removeClass('active');
        }

        $(`.tariffs__types button[data-type="${type}"]`).addClass('active');
        $(`.tariffs__items[data-type="${type}"]`).addClass('active');

        if ($(`.tariffs__more[data-type="${type}"]`).length) {
            $(`.tariffs__more[data-type="${type}"]`).addClass('active');
        }
    });
    $('.tariffs__more').on('click', function() {
        const type = $(this).data('type');

        $(`.tariffs__items[data-type="${type}"] .tariffs__item`).removeClass('active').addClass('active');
        $(this).remove();
    });
});

// mobile menu
// $(() => {
//     $('.header__burger').on('click', function() {
//         $(this).toggleClass('open');
//         $('#menu').toggleClass('open');
//         $('html').toggleClass('no-scroll');
//     });
// });

// modals
$(() => {
    $('[data-modal]').on('click', function() {
        const modalID = $(this).data('modal');

        if (!$('html').hasClass('no-scroll')) {
            $('html').addClass('no-scroll');
        }
        $('.modal').removeClass('open');

        if (modalID === 'menu') {
            $('.header__burger').toggleClass('open');

            if (!$('.header__burger').hasClass('open')) {
                $('html').removeClass('no-scroll');
                return;
            }
        } else {
            $('.header__burger').removeClass('open');
        }

        if (modalID === 'order-phone') {
            $('#order form input[name="service"]').val($(this).data('service'));
            $('#order form input[name="price"]').val($(this).data('price'));
        }

        $(`#${modalID}`).addClass('open');
    });

    $('.modal__close').on('click', function(e) {
        const modalID = $(this).parents('modal').attr('id');

        if (modalID === 'menu') {
            $('.header__burger').removeClass('open');
        }

        $('html').removeClass('no-scroll');
        $('.modal').removeClass('open');
    });

    $('.modal').on('click', function(e) {
        if ($(e.target).hasClass('modal')) {
            const modalID = $(e.target).attr('id');

            if (modalID === 'menu') {
                $('.header__burger').removeClass('open');
            }

            $('html').removeClass('no-scroll');
            $('.modal').removeClass('open');
        }
    });
});

// cities
$(() => {
    if (window.matchMedia('(max-width: 767px)').matches) {
        $('.modal.cities .cities__regions .regions__item .item__list button').on('click', function() {
            $(this).toggleClass('open');
        });
    } else {
        $('.modal.cities .cities__regions .regions__item .item__list button').on('mouseover', function() {
            const regionID = $(this).data('region-id');
            $('.modal.cities .cities__items').removeClass('open');
            $('.modal.cities .cities__regions .regions__item .item__list button').removeClass('open');
            $(`.modal.cities .cities__items[data-region-id="${regionID}"]`).addClass('open');
            $(this).addClass('open');
            console.log(regionID);
            // $(this).toggleClass('open');
        });
    }
});

// connect form
$(() => {
    const $form = $('#connect form');
    let suggestData = null;
    let searchTimeout;

    const renderItems = (data) => {
        const $list = $('.dropdown-address__list');
        $list.html(null);

        const noAddress = `<button type="button" data-id="">Нет моего адреса</button>`;
        $list.append(noAddress);

        data.forEach((item) => {
            const tmp = `<button type="button" data-id="${item.id}">${item.full}</button>`;
            $list.append(tmp);
        });

        if (!$('.dropdown-address').hasClass('open')) $('.dropdown-address').addClass('open');
    }
    const renderItemsV2 = (data) => {
        const $list = $('.dropdown-address__list');
        $list.html(null);

        data.forEach((item, i) => {
            const tmp = `<button type="button" data-id="${i}">${item.value}</button>`;
            $list.append(tmp);
        });

        if (!$('.dropdown-address').hasClass('open') && data.length) $('.dropdown-address').addClass('open');
    }
    const checkFields = () => {
        const $btn = $form.find('.btn[type="submit"]');
        const phone = $form.find('input[name="phone"]').val();
        const address = $form.find('input[name="address"]').val();

        phone.length && address.length ? $btn.prop('disabled', false) : $btn.prop('disabled', true);
    }

    $('#connect input[name="address"]').on('input', async function() {
        const value = $(this).val();

        clearTimeout(searchTimeout);

        if (value.length < 3) return;

        searchTimeout = setTimeout(async () => {
            try {
                const formData = new FormData();

                formData.append('action', 'searchAddressV2');
                formData.append('where', 'dadata');
                
                formData.append('search', value);

                const request = await fetch('/assets/components/api/actions.php', {
                    method: 'POST',
                    body: formData
                });
                
                const response = await request.json();

                if (response.error) {
                    alert(response.message);
                    return;
                }

                suggestData = response.data;

                renderItemsV2(response.data);
            } catch (error) {
                console.error('Запрос прерван или произошла ошибка:', error);
            }
        }, 300);

        checkFields();
    });
    $('#connect input[name="phone"], #connect input[name="flat"]').on('input', function() {
        localStorage.setItem($(this).attr('name'), $(this).val());
        checkFields();
    });

    $(document).on('click', '.dropdown-address__list button', function() {
        const index = +$(this).data('id');
        const addressData = suggestData[index];

        if (!addressData) return;

        $('#connect input[name="address"]').val(addressData.value);
        localStorage.setItem('address', addressData.value);

        if (addressData.data.flat) {
            $('#connect input[name="flat"]').val(addressData.data.flat);
            localStorage.setItem('flat', addressData.data.flat);
        }

        $('#connect .dropdown-address').removeClass('open');
        checkFields();
    });

    $form.on('submit', async function(e) {
        e.preventDefault();

        const fields = {
            addressID: $(this).find('input[name="addressID"]').val(),
            phone: $(this).find('input[name="phone"]').val(),
            address: $(this).find('input[name="address"]').val(),
            flat: $(this).find('input[name="flat"]').val()
        };

        const cleanPhone = fields.phone.replace(/\D/g, '');
        if (cleanPhone.length !== 11) {
            alert('Укажите корректный телефон');
            return;
        }

        if (typeof Comagic !== 'undefined') {
            Comagic.addOfflineRequest({
                phone: cleanPhone,
            });
        }

        const formData = new FormData();
        
        formData.append('action', 'checkConnection');

        for(const key in fields) {
            formData.append(key, fields[key]);
        }

        const btnText = $form.find('.btn[type="submit"]').text();
        $form.find('.btn[type="submit"]').prop('disabled', true).text('Отправка...');

        const request = await fetch('/assets/components/api/actions.php', {
            method: 'POST',
            body: formData
        });
        
        const response = await request.json();

        $form.find('.btn[type="submit"]').prop('disabled', true).text(btnText);

        if (response.error) {
            alert(response.message);
            return;
        }

        window.location.href = response.redirect;

        return;
    });
});

// order form
$(() => {
    const $form = $('#order form');

    if (localStorage.getItem('phone')) {
        $('#order form input[name="phone"]').val(localStorage.getItem('phone'));
    }
    if (localStorage.getItem('address')) {
        $('#order form input[name="address"]').val(localStorage.getItem('address'));
    }
    if (localStorage.getItem('flat')) {
        $('#order form input[name="flat"]').val(localStorage.getItem('flat'));
    }

    $form.on('submit', async function(e) {
        e.preventDefault();

        const fields = {
            city: $(this).find('input[name="city"]').val(),
            service: $(this).find('input[name="service"]').val(),
            name: $(this).find('input[name="name"]').val(),
            phone: $(this).find('input[name="phone"]').val(),
            address: $(this).find('input[name="address"]').val(),
            flat: $(this).find('input[name="flat"]').val(),
            price: $(this).find('input[name="price"]').val(),
        };

        const cleanPhone = fields.phone.replace(/\D/g, '');
        if (cleanPhone.length !== 11) {
            alert('Укажите корректный телефон');
            return;
        }

        if (typeof Comagic !== 'undefined') {
            Comagic.addOfflineRequest({
                phone: cleanPhone,
            });
        }

        const formData = new FormData();
        
        formData.append('action', 'sendForm');

        for(const key in fields) {
            formData.append(key, fields[key]);
        }

        const btnText = $form.find('.btn[type="submit"]').text();
        $form.find('.btn[type="submit"]').prop('disabled', true).text('Отправка...');

        const request = await fetch('/assets/components/api/actions.php', {
            method: 'POST',
            body: formData
        });
        
        const response = await request.json();

        $form.find('.btn[type="submit"]').prop('disabled', true).text(btnText);

        if (response.error) {
            alert(response.message);
            return;
        }

        localStorage.removeItem('phone');
        localStorage.removeItem('address');
        localStorage.removeItem('flat');

        window.location.href = response.redirect;

        return;
    });
});

// callback form
$(() => {
    const $form = $('.callback__form');

    if (localStorage.getItem('phone')) {
        $('.callback__form input[name="phone"]').val(localStorage.getItem('phone'));
    }
    if (localStorage.getItem('address')) {
        $('.callback__form input[name="address"]').val(localStorage.getItem('address'));
    }
    if (localStorage.getItem('flat')) {
        $('.callback__form input[name="flat"]').val(localStorage.getItem('flat'));
    }

    $form.on('submit', async function(e) {
        e.preventDefault();

        const fields = {
            city: $(this).find('input[name="city"]').val(),
            name: $(this).find('input[name="name"]').val(),
            phone: $(this).find('input[name="phone"]').val(),
            address: $(this).find('input[name="address"]').val(),
            flat: $(this).find('input[name="flat"]').val()
        };

        const cleanPhone = fields.phone.replace(/\D/g, '');
        if (cleanPhone.length !== 11) {
            alert('Укажите корректный телефон');
            return;
        }

        if (typeof Comagic !== 'undefined') {
            Comagic.addOfflineRequest({
                phone: cleanPhone,
            });
        }

        const formData = new FormData();
        
        formData.append('action', 'sendForm');

        for(const key in fields) {
            formData.append(key, fields[key]);
        }

        const btnText = $form.find('.btn[type="submit"]').text();
        $form.find('.btn[type="submit"]').prop('disabled', true).text('Отправка...');

        const request = await fetch('/assets/components/api/actions.php', {
            method: 'POST',
            body: formData
        });
        const response = await request.json();

        $form.find('.btn[type="submit"]').prop('disabled', true).text(btnText);

        if (response.error) {
            alert(response.message);
            return;
        }

        localStorage.removeItem('phone');
        localStorage.removeItem('address');
        localStorage.removeItem('flat');

        window.location.href = response.redirect;

        return;
    });
});

// search city
const EN_TO_RU_LAYOUT = {
    'q': 'й', 'w': 'ц', 'e': 'у', 'r': 'к', 't': 'е', 'y': 'н', 'u': 'г', 'i': 'ш', 'o': 'щ', 'p': 'з',
    '[': 'х', ']': 'ъ', 'a': 'ф', 's': 'ы', 'd': 'в', 'f': 'а', 'g': 'п', 'h': 'р', 'j': 'о', 'k': 'л',
    'l': 'д', ';': 'ж', "'": 'э', 'z': 'я', 'x': 'ч', 'c': 'с', 'v': 'м', 'b': 'и', 'n': 'т', 'm': 'ь',
    ',': 'б', '.': 'ю', '/': '.',
    'Q': 'Й', 'W': 'Ц', 'E': 'У', 'R': 'К', 'T': 'Е', 'Y': 'Н', 'U': 'Г', 'I': 'Ш', 'O': 'Щ', 'P': 'З',
    '{': 'Х', '}': 'Ъ', 'A': 'Ф', 'S': 'Ы', 'D': 'В', 'F': 'А', 'G': 'П', 'H': 'Р', 'J': 'О', 'K': 'Л',
    'L': 'Д', ':': 'Ж', '"': 'Э', 'Z': 'Я', 'X': 'Ч', 'C': 'С', 'V': 'М', 'B': 'И', 'N': 'Т', 'M': 'Ь',
    '<': 'Б', '>': 'Ю', '?': ',',
    '`': 'ё', '~': 'Ё',
};

const convertEnToRuLayout = (str) => str.split('').map((char) => EN_TO_RU_LAYOUT[char] || char).join('');

$(() => {
    let searchTimeout;

    const renderItems = (data) => {
        const $list = $('.dropdown-city__list');
        $list.html(null);

        if (!data.length) {
            $('.dropdown-city').removeClass('open');
            return;
        }

        data.forEach((item) => {
            const tmp = `<button type="button" data-link="${item.link}">${item.name} (${item.region})</button>`;
            $list.append(tmp);
        });

        if (!$('.dropdown-city').hasClass('open')) $('.dropdown-city').addClass('open');
    }

    $('#cities input[name="city"]').on('input', async function() {
        const value = $(this).val();

        clearTimeout(searchTimeout);

        if (!value.length) $('.dropdown-city').removeClass('open');
        if (value.length < 3) return;

        searchTimeout = setTimeout(async () => {
            try {
                const searchValue = convertEnToRuLayout(value);

                const formData = new FormData();
                formData.append('action', 'searchCity');
                formData.append('search', searchValue);

                const request = await fetch('/assets/components/api/actions.php', {
                    method: 'POST',
                    body: formData
                });
                
                const response = await request.json();

                if (response.error) {
                    alert(response.message);
                    return;
                }

                renderItems(response.data);

                console.log(response);
            } catch (error) {
                console.error('Запрос прерван или произошла ошибка:', error);
            }
        }, 300);
    });

    $(document).on('click', '.dropdown-city__list button', function() {
        const link = $(this).data('link');

        $('.dropdown-city').removeClass('open');

        window.location.href = link;
    });
});

// cookie policy
$(() => {
    const isVisible = +localStorage.getItem('cookie-policy');

    if (!isVisible) {
        $('.cookie-policy').css('display', 'flex');
    }

    $('.cookie-policy button').on('click', function() {
        localStorage.setItem('cookie-policy', '1');
        $('.cookie-policy').css('display', 'none');
    });
});

// save GET params
$(() => {
    const currentParams = window.location.search;
    
    if (currentParams) {
        $('a').each(function() {
            const href = $(this).attr('href');
            
            if (href && !href.match(/^(mailto:|tel:|javascript:|#)/) && this.hostname === window.location.hostname) {
                const separator = href.includes('?') ? '&' : '?';
                const cleanParams = currentParams.startsWith('?') ? currentParams.substring(1) : currentParams;
                
                $(this).attr('href', href + separator + cleanParams);
            }
        });
    }
})